export const clamp = (value: number, min = 0, max = 100) =>
    Math.max(min, Math.min(max, value));

export const minMaxNormalize = (value: number, min: number, max: number, invert = false) => {
    if (max === min) {
        return 50;
    }

    const normalized = ((value - min) / (max - min)) * 100;
    return clamp(invert ? 100 - normalized : normalized);
};

export const normalizeSeries = (values: number[], invert = false) => {
    const min = Math.min(...values);
    const max = Math.max(...values);

    return values.map((value) => minMaxNormalize(value, min, max, invert));
};

export const mean = (values: number[]) => {
    if (!values.length) {
        return 0;
    }

    return values.reduce((acc, value) => acc + value, 0) / values.length;
};

export const stdDev = (values: number[]) => {
    if (values.length <= 1) {
        return 0;
    }

    const avg = mean(values);
    const variance = values.reduce((acc, value) => acc + (value - avg) ** 2, 0) / values.length;
    return Math.sqrt(variance);
};

export const coefficientOfVariation = (values: number[]) => {
    const avg = mean(values);
    if (avg === 0) {
        return 0;
    }

    return stdDev(values) / avg;
};

export const toStars = (normalized: number) => {
    if (normalized >= 80) return '★★★★★';
    if (normalized >= 60) return '★★★★☆';
    if (normalized >= 40) return '★★★☆☆';
    if (normalized >= 20) return '★★☆☆☆';
    return '★☆☆☆☆';
};

export const getPercentilBand = (percentil: number) => {
    if (percentil <= 1) return 'Top 1%';
    if (percentil <= 5) return 'Top 5%';
    if (percentil <= 10) return 'Top 10%';
    if (percentil <= 20) return 'Top 20%';
    if (percentil <= 30) return 'Top 30%';
    if (percentil <= 50) return 'Top 50%';
    return 'Abaixo do Top 50%';
};
